import React from 'react';
import PropTypes from 'prop-types';

import { cn } from 'shadcn/lib/utils';

const DEFAULT_CARD_WIDTH_CLASS = 'w-[18rem] sm:w-[19rem] lg:w-[20rem]';

/**
 * Lays out one or more related entity summary cards with consistent sizing in a horizontal scroll track.
 *
 * @param {Object} props - Component props.
 * @param {React.ReactNode | React.ReactNode[]} props.cards - Summary card elements to display.
 * @returns {JSX.Element | null} Container markup when cards are provided, otherwise null.
 */
export function ViewEntityAddInfoSummaryCardContainer({ cards }) {
    const items = React.Children.toArray(cards).filter(Boolean);

    if (items.length === 0) {
        return null;
    }

    return (
        <aside data-slot="entity-related-summary" className={cn('flex flex-col gap-4 lg:gap-6')}>
            <div
                data-slot="entity-related-summary-scroll"
                className={cn('flex w-full snap-x snap-mandatory gap-4 overflow-x-auto', 'px-1 pb-3')}
            >
                {items.map((card, index) => (
                    <section
                        key={card?.key ?? `entity-summary-card-${index}`}
                        data-slot="entity-related-summary-card"
                        className={cn('flex shrink-0 grow-0 snap-start', DEFAULT_CARD_WIDTH_CLASS)}
                    >
                        {card}
                    </section>
                ))}
            </div>
        </aside>
    );
}

ViewEntityAddInfoSummaryCardContainer.propTypes = {
    cards: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
};

ViewEntityAddInfoSummaryCardContainer.defaultProps = {
    cards: undefined,
};

ViewEntityAddInfoSummaryCardContainer.displayName = 'ViewEntityAddInfoSummaryCardContainer';
